export default {
	BASE_STORAGE: process.env.REACT_APP_BASE_STORAGE,
	BASE_API: process.env.REACT_APP_BASE_API,
	BASE_PUBLIC: process.env.REACT_APP_BASE_PUBLIC,
	TIMEZONE: 'America/Caracas',
	LEVELS: {
		ADMIN: 1,
		OPERATOR: 2,
		CLIENT: 3,
		MODERATOR: 4
	},
	CURRENCIES: {
		DOLAR: 1,
		BOLIVAR: 2
	},
	MODULES: {
		MODERATORS: 1,
	    SERVICES: 2,
	    OPERATORS: 4,
	    EXCHANGE: 5,
	    QUOTES: 6,
	    REPORTS: 7,
	    CLIENTS: 8,
	    BANK_ACCOUNTS: 9,
	    DISCOUNTS: 10,
	    ORDERS: 11,
	    INVENTORY: 12,
	    PRODUCTS: 13,
	    COMBOS: 14,
	    BANNERS: 15,
	    CATEGORIES: 16,
	    PRICE_METER: 17,
	    CORPORATE_PAYMENTS: 18,
	    ACCESSORIES: 19,
	    JOB_APPLICATIONS: 20,
	    POINTS: 21,
	    PLANNING: 22,
	    EXCLUDED_PLACES: 23,
	    JOURNEYS: 24,
	    QUOTE_TYPES: 25
	},
	SERVICE_STATUS: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	QUOTE_STATUS: {
	    PENDING: 1,
	    ASSIGNED: 2,
	    IN_PROGRESS: 3,
	    FINISH: 4,
	    CANCELLED: 5
	},
	QUOTE_TYPES_STATUS: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	PAYMENT_METHODS: {
	    MOVIL: 1,
	    ZELLE: 2,
	    TRANSFER: 3,
	    BFC: 4,
	    CASH: 5,
	    STRIPE: 6,
	    CORPORATE: 7,
	    CASH2: 8
	},
	CURRENCIES_SYMBOL: {
		BOLIVAR: 'Bs.',
		DOLAR: '$'
	},
	FULL_JOURNEY: 1,
	QUOTE_PAYMENT_STATUS: {
	    PENDING: 0,
	    APPROVED: 1,
	    REJECTED: 2
	},
	DISCOUNT_STATUS: {
	    ACTIVE: 1,
	    INACTIVE: 0
  	},
  	DOCUMENT_TYPES: {
  		V: 1,
		E: 2,
		J: 3,
		G: 4
  	},
  	PAGES: {
	    SERVIZI: 1,
	    SPLENDOR: 2
	},
	BANNERS: {
	    PRINCIPAL: 1,
	    SECONDARY: 2,
	    ADVERTISING: 3
	},
	PRODUCT_TYPES: {
		PRODUCT: 1,
		COMBO: 2
	},
	PRODUCT_STATUS: {
	    ACTIVE: 1,
	    INACTIVE: 0
	},
	ORDERS_STATUS: {
	    PENDING: 0,
	    FINISH: 1
	},
	ORDERS_PAYMENT_STATUS: {
    	PENDING: 0,
    	ACCEPTED: 1,
    	REJECTED: 2
  	},
  	MOVEMENT_TYPES: {
	    ADD: 1,
	    REMOVE: 2,
	    ORDER: 3,
	    PAYMENT_REJECTED: 4
	},
	QUOTE_TYPES: {
		NORMAL: 1,
		DEEP: 2,
		URGENT: 3,
		CUSTOM: 4
	},
	USER_TYPES: {
		COMMON: 1,
		CORPORATE: 2,
		SUBUSER: 3
	},
	VALIDATION_STATUS: {
	    INACTIVE: 0,
	    ACTIVE: 1
	},
	QUOTES_ORIGIN: {
	    NORMAL: 1,
	    ADMIN: 2
	},
	SERVICE_TYPES: {
	    CLEAN: 1,
	    OTHERS: 2
	},
	PLANNING_STATUS: {
		PENDING: 0,
		ASSIGN: 1
	},
	INCLUDE_MARQUEE: {
	    YES: 1,
	    NO: 0
	}
}